import CookiePolicyContainer from "./container/CookiePolicyContainer";

export default CookiePolicyContainer;
